import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getLiscodeSlice = createAsyncThunk(
  "lisCode/getLiscode",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/liscode/getLiscode",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
);

const initialState = {
  loading: false,
  liscodes: []
};

const liscodeSlice = createSlice({
  name: "liscode",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLiscodeSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getLiscodeSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.searchLiscodeErrorMessage = action.payload.result.message;
        }
        state.liscodes = action.payload.result.list;
      })
      .addCase(getLiscodeSlice.rejected, (state, action) => {
        state.loading = false;
        state.searchLiscodeErrorMessage = action.payload.result.message;
      })
  },
});

export default liscodeSlice.reducer;